export class AbstractChartDTO {

  availableChartId: number;
  score: number;
  position: number;
  diffScore: number;
  diffPosition: number;

}
